module.exports = __webpack_public_path__ + "static/sheet-declarative-75a6c9f4742a0df68975a647a4f8face.gif";